<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="$t('invoices.download_files_config')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ $t('invoices.download_files_config') }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="value">
              <AccessibleElSelect
                v-model="form.value"
                prop="value"
                :options="metadatosForAccessibleSelect"
                :isDisabled="loadingLocal"
                :placeholder="$t('invoices.download_files_default_id')"
              >
                <template slot="label">{{ $t('invoices.download_files_rename_by_metadata') }}</template>
              </AccessibleElSelect>
            </div>
            <div>
              <span id="download-zip-filter-nombre-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.download_files_filter_name') }}</span>
                <el-form-item prop="nombre">
                  <el-input
                    class="w-full"
                    autocomplete="off"
                    type="text"
                    v-model="form.nombre"
                    :placeholder="$t('invoices.download_files_all_default')"
                    maxlength='50'
                    aria-labelledby="download-zip-filter-nombre-label"
                  >
                    <template v-if="form.nombre" slot="suffix">
                      <base-clear-input-button
                        :aria-label="$t('invoices.download_files_clear_filter_name')"
                        @clear="form.nombre = ''"
                      />
                    </template>
                  </el-input>
                </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button 
        @click="toggleDialog" 
        class="w-full" 
        mode="secondary-phantom-blue" 
        :text="$t('app.cancel')" 
        :loading="loadingLocal" 
        :disabled="loadingLocal"/>
      <base-button 
        mode="secondary-phantom-blue" 
        class="w-full" 
        :text="$t('app.accept')" 
        @click="apply('ruleForm')" 
        :loading="loadingLocal" 
        :disabled="loadingLocal"/>
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'
import BaseDialogButton from './base/BaseDialogButton.vue'
import AccessibleElSelect from './elementui/AccessibleElSelect.vue'
import { getCamposMetadatos } from '@/services/clients/lists/getCamposMetadatos'

export default
{
  name: 'input-text-dialog',
  components: {
    BaseDialogButton,
    AccessibleElSelect
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      metadatos: [],
      form: {
        value: '',
        nombre: '',
      },
      loadingLocal: false,
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      this.form.value = ''
      this.form.nombre = ''
      this.loadingLocal = false
      if (value) {
        this.loadMetadatos()
      } else {
        this.metadatos = []
      }
    }
  },
  mounted: async function () {
  },
  computed: {
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    role: function () {
      return this.$store.getters['auth/role'].toLowerCase()
    },
    metadatosForAccessibleSelect: function () {
      return this.metadatos.map(m => ({ id: m.value, name: m.label }))
    }
  },
  methods: {
    loadMetadatos: async function () {
      this.metadatos = []
      // Carga de campos de metadatos
      const metadatos = await getCamposMetadatos()
      if (metadatos.blnError) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', metadatos))
      } else {
        metadatos.Respuesta.forEach(x => {
          const metadato = { value: x, label: x }
          this.metadatos.push(metadato)
        })
      }
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    apply: async function () {
      this.isOpen = !this.isOpen
      this.loadingLocal = true
      this.$emit('applyDialog', this.form)
    },
  }
}
</script>

<style lang="scss" scoped></style>
